module.exports = __webpack_public_path__ + "static/media/explore_hubs_pers.4b20a610.svg";